import { getImage } from '../../../../utils/imageHelper';

function NewsItem({ news, handleClickNews, handleDuplicateNews }) {
  return (
    <div
      className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100 w-full"
      onClick={handleClickNews}>
      <img
        className="h-20 shadow-md block rounded-md"
        src={news.image ? news.image.file : getImage('img-ph.png')}
        alt={news.image ? news.image.label : 'Non renseignée'}
      />
      <div className="flex flex-col justify-around h-full w-full">
        <div className="flex flex-col gap-y-1">
          <div className="text-xl font-bold text-slate-700 ">{news.title}</div>
        </div>
      </div>
    </div>
  );
}

export default NewsItem;
